import script from "./Rule3Osastav.vue?vue&type=script&setup=true&lang=ts"
export * from "./Rule3Osastav.vue?vue&type=script&setup=true&lang=ts"

import "./Rule3Osastav.vue?vue&type=style&index=0&id=1a7d1e14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a7d1e14"]])

export default __exports__